var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-product-box"},[_c('CartItemView',{attrs:{"cart-item":_vm.cartItem,"cart":_vm.cart,"save-handler":_vm.mappedSaveHandler,"webshop":_vm.webshop,"old-item":_vm.oldItem,"admin":_vm.admin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }